import YellowAIChatbot from './YellowAIChatbot';

export default YellowAIChatbot;
